module.exports = __webpack_public_path__ + "static/img/13.4c68280.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/13.png
// module id = vQN6
// module chunks = 0